/**
 * Reads an image file as a base64 data URL (passed to `onBase64` once loaded)
 * and returns an object URL to preview it right away.
 */
export function readImageFile(file, onBase64) {
  const reader = new FileReader();
  reader.onload = () => onBase64(reader.result);
  reader.readAsDataURL(file);
  return URL.createObjectURL(file);
}
